import { render, staticRenderFns } from "./detailedReport.vue?vue&type=template&id=1c8e16e4&scoped=true"
import script from "./detailedReport.vue?vue&type=script&lang=js"
export * from "./detailedReport.vue?vue&type=script&lang=js"
import style0 from "./detailedReport.vue?vue&type=style&index=0&id=1c8e16e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8e16e4",
  null
  
)

export default component.exports